import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { isNullOrEmpty, translate } from '../../utils/util';
import SelectNew from '../../components/UI/SelectNew';
import LoadUnloadService from '../../services/LoadUnloadService';
import { onValueChange, validateInputsRequired } from '../../utils/handleChangeHooks';
import { Input, Label, SelectRackType } from '../../components/UI/ComponentsUI';
import InputUI from '../../components/UI/InputUI';
import SelectSupplier from '../../components/UI/SelectSupplier';
import ConfirmModalUI from '../../components/UI/ConfirmModalUI';

const LoadUpdateItem = (props) => {
  const [mdrSupplierNotFoundMessage, setMdrSupplierNotFoundMessage] = useState(undefined);
  const [openConfirmModal, setOpenConfirmModal] = useState();
  const [model, setModel] = useState(
    {
      shippingCompany: props.shedObj?.companies ? props.shedObj?.companies[0].companyId : ''
    });
  const [isPackingFCM, setIsPackingFCM] = useState(false);

  useEffect(() => {
    const newModel = {
      id: props.data.id,
      rackTypeUpdate: props.data.rackType,
      supplierUpdate: props.data.supplier,
      qtdUpdate: props.data.qtd,
      fullPackagingUpdate: props.data.fullPackaging,
      transportOrderUpdate: props.data.transportOrder,
      shippingCompanyUpdate: props.data.shippingCompany,
      finishAE: props.data.finishAE
    }
    var dataUpdate = {
      ...newModel,
      ...model
    }
    setModel({ ...dataUpdate })
    // eslint-disable-next-line
  }, [props.data]);


  const onChange = (event) => {
    onValueChange(event, model, setModel);
  };

  const onChangeRackType = (event) => {
    model.rackTypeUpdate = event;
    setModel({ ...model });
    verifyShowTransportOrder();
  };

  const onChangeSupplier = (event) => {
    model.supplierUpdate = event;
    setModel({ ...model });
    verifyShowTransportOrder();
  };

  const getshippmentCompany = (value) => {
    if (!isNullOrEmpty(value) && props?.shedObj?.companies && props.shedObj.companies.length > 0) {
      return props?.shedObj?.companies.find((f) => f.companyId === parseInt(value))
    }
    return null;
  }

  const validateUpdateItem = () => {
    if (!validateInputsRequired('formUpdateLoadItem')) return;
        
    const rackTypeField = document.getElementById('rackTypeUpdate').value;
    const supplierField = document.getElementById('supplierUpdate').value.split('-')[0].trim();

    // Usuario nao escolheu vasilhame, ou escolheu mas digitou outro valor invalido no campo:
    if((model.rackTypeUpdate?.id ?? 0) === 0 || !props.rackTypeList.some(x => x.code === rackTypeField)) {
      setMdrSupplierNotFoundMessage(translate("mdrNotFound", "load-unload"));
      return;
    }

    // Usuario nao escolheu fornecedor, ou digitou valor invalido
    if((model.supplierUpdate?.supplierID ?? 0) === 0 || supplierField !== String(model.supplierUpdate.supplierID)) {
      setMdrSupplierNotFoundMessage(translate("supplierNotFound", "load-unload"));
      return;
    }


    props.checkRackTypeSupplier(model.shippingCompanyUpdate, model.rackTypeUpdate.id, model.supplierUpdate.supplierID, (hasAssociation) => {
      if (hasAssociation)
      {
        updateItem();
      }
      else
      {
        setOpenConfirmModal(true);
      }
    });
  };

  const updateItem = () => {
    var company = getshippmentCompany(model.shippingCompanyUpdate);
    let itemEdit = {
      id: props.data.id,
      rackTypeId: model.rackTypeUpdate.id,
      rackTypeCode: model.rackTypeUpdate.code,
      rackTypeDescription: model.rackTypeUpdate.description,
      rackTypeOwnerSupplierId: model.rackTypeUpdate.ownersupplierId,
      mvmShedId: props.shed,
      supplierId: model.supplierUpdate.supplierID,
      supplierName: model.supplierUpdate.name,
      supplierUF: model.supplierUpdate.supplierUf,
      volumeQuantity: model.qtdUpdate,
      indFullRack: model.fullPackagingUpdate,
      requestNumber: model.transportOrderUpdate,
      shippingCompanyId: model.shippingCompanyUpdate,
      shippingCompanyUF: company.companyUF,
      shippingCompanyCode: company.companyCode,
      shippingCompanyName: company.companyName,
      isPackingFCM: model.isPackingFCM
    };
    props.updateConfirmationMdrList(itemEdit);
    setIsPackingFCM(false);
    verifyShowTransportOrder();
    props.clearSelectItem();
  }

  const verifyShowTransportOrder = () => {

    props.verifyShowTransportOrder(model.rackTypeUpdate?.code, model.supplierUpdate?.supplierID, (data) => {
      model.isPackingFCM = data;
      setModel({ ...model });
      setIsPackingFCM(data);
    })
  }

  const getshippmentCompanie = (value) => {
    if (!isNullOrEmpty(value) && props?.shedObj?.companies && props.shedObj.companies.length > 0) {
      return props?.shedObj?.companies.find((f) => f.companyId === parseInt(value))
    }
    return null;
  }

  return (
    props.update ?
      <div id='formUpdateLoadItem' className="row" style={{ marginBottom: '0px' }}>
        <div className="input-field no-padding col s5">
          <SelectRackType
            required
            id="rackTypeUpdate"
            defaultValue={model.rackTypeUpdate?.id || ''}
            value={model.rackTypeUpdate?.id || ''}
            onChangeData={onChangeRackType}
          />
        </div>
        <div className="input-field no-padding col s6">
          <SelectSupplier
            required
            name="supplierUpdate"
            id="supplierUpdate"
            focus="true"
            defaultValue={model.supplierUpdate?.supplierID}
            value={model.supplierUpdate?.supplierID || ""}
            onChange={onChangeSupplier}
          />
        </div>
        <div className="input-field no-padding col s4">
          <Input
            required
            label={translate('qtd', 'load-unload')}
            id="qtdUpdate"
            name="qtdUpdate"
            type="number"
            onChange={onChange}
            value={model?.qtdUpdate || ''}>
          </Input>
        </div>
        {isPackingFCM &&
          <div className="input-field no-padding col s7">
            <InputUI
              label={translate('transport-order', 'load-unload')}
              id="transportOrderUpdate"
              name="transportOrderUpdate"
              type="number"
              onChange={onChange}
              value={model?.transportOrderUpdate || ''}>
            </InputUI>
          </div>
        }
        <div className="input-field no-padding col s7" style={{ marginTop: '30px' }}>
          <InputUI
            id="fullPackagingUpdate"
            name="fullPackagingUpdate"
            type="checkbox"
            label={translate('full-packaging', 'load-unload')}
            onChange={onChange}
            defaultChecked={model?.fullPackagingUpdate || ''}
          />
        </div>
        <div className="input-field no-padding col s10">
          <SelectNew
            required
            id={'shippingCompanyUpdate'}
            name="shippingCompanyUpdate"
            label={translate('shipping-company', 'load-unload')}
            placeHolder={translate('choose-one-option', 'general')}
            data={props?.shedObj?.companies ? props.shedObj.companies.map((i) => {
              return { id: i.companyId, text: i.companyName };
            }) : []}
            value={model?.shippingCompanyUpdate || ''}
            change={(evt) => {
              onChange(evt);
            }}
          />
        </div>
        <div id={model.id} className="input-field no-padding col s1" style={{ marginTop: '50px' }}>
          <i className={'mdi mdi-36px mdi-content-save'}
            onClick={validateUpdateItem}
            style={{ color: "blue", cursor: "pointer" }} />
        </div>

        <ConfirmModalUI
          open={openConfirmModal}
          showCancel="true"
          id="confirmModal"
          data={{
              title: translate('warning', 'general'),
              message: translate('unrelatedRackTypeQuestion', 'load-unload').replace("{0}", model.rackTypeUpdate?.code ?? "").replace("{1}", model.supplierUpdate?.supplierID)
          }}
          onConfirm={() => {
              setOpenConfirmModal(false)
              updateItem()
          }}
          onCancel={() => setOpenConfirmModal(false)}
          onClose={() => setOpenConfirmModal(false)}
          btnCancel={translate('cancel', 'general')}
          btnConfirm={translate('confirm', 'general')}
        />

        <ConfirmModalUI
              open={mdrSupplierNotFoundMessage}
              id="modalNotExists"
              data={{ title: translate('validations:attention'), message: mdrSupplierNotFoundMessage }}
              onConfirm={() => setMdrSupplierNotFoundMessage(undefined)}
              onClose={() => setMdrSupplierNotFoundMessage(undefined)}
              showCancel={false}
              btnConfirm="OK"
        />

      </div> :
      <div key={props.data.id} style={{ paddingBlock: '10px' }}>
        <fieldset className='fieldset'>
          <legend style={{ padding: '0 5px' }}>Vasilhame</legend>
          <div className="row" style={{ marginBottom: '0px' }}>
            <Label field="f-1.5r" class="col s12" id="supplier" label={translate('supplier', 'load-unload')} value={`${props.data.supplier?.supplierID}-${props.data.supplier?.name}`} />
            <Label field="f-1.5r" class="col s6" id="rackType" label={translate('mdr', 'load-unload')} value={`${props.data.rackType?.code}-${props.data.rackType?.description}`} />
            <Label field="f-1.5r" class="col s5" id="length" label={translate('qtd', 'load-unload')} value={props.data?.qtd} />
            <Label field="f-1.5r" class="col s12" id="length" label={translate('shipping-company', 'load-unload')} value={getshippmentCompanie(props.data?.shippingCompany)?.companyName} />
            {
              !isNullOrEmpty(props.data.transportOrder) &&
              <Label field="f-1.5r" class="col s12" id="length" label={translate('transport-order', 'load-unload')} value={props.data.transportOrder} />
            }
          </div>
        </fieldset>
      </div>
  );
};


const mapStateToProps = (state) => {
  return {
    rackTypeList: state.loadUnloadReducer.rackTypeList,
    supplierList: state.supplierReducer.supplierList,
    shedObj: state.loadUnloadReducer.shedObj,
    user: state.userReducer.user,
    confirmationList: state.loadUnloadReducer.confirmationList,
    mvm: state.loadUnloadReducer.mvm
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getIsPackingFCM: (rackTypeCode, supplierCode, callback) => {
      dispatch(LoadUnloadService.getIsPackingFCM(rackTypeCode, supplierCode, callback));
    },
    updateConfirmationMdrList: (item) => {
      dispatch(LoadUnloadService.updateConfirmationMdrList(item));
    },
    removeConfirmationMdrList: (item) => {
      dispatch(LoadUnloadService.removeConfirmationMdrList(item));
    },
    checkRackTypeSupplier: (companyId, rackTypeId, supplierId, callback) => {
      dispatch(LoadUnloadService.checkRackTypeSupplier(companyId, rackTypeId, supplierId, callback));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LoadUpdateItem));
